(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[10697],{

/***/ 37767:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/antiviruschoice",
      function () {
        return __webpack_require__(4670);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/layouts/antiVirusChoiceWrapper.tsx
var antiVirusChoiceWrapper = __webpack_require__(74937);
// EXTERNAL MODULE: ./src/components/antiviruschoice/topThree/topThree.module.scss
var topThree_module = __webpack_require__(70375);
var topThree_module_default = /*#__PURE__*/__webpack_require__.n(topThree_module);
// EXTERNAL MODULE: ./src/components/antiviruschoice/svg/badge.tsx
var badge = __webpack_require__(95830);
// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx + 1 modules
var affiliateOfferUrl = __webpack_require__(25416);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
;// CONCATENATED MODULE: ./src/components/antiviruschoice/topThree/index.tsx






const TopThree = ({ withTitle , listing , gradient  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `md:pb-14 flex flex-col justify-center items-center py-4 px-4 ${gradient === "blue" ? (topThree_module_default())["bg-top-gradient-blue"] : (topThree_module_default())["bg-top-gradient-gray"]}`,
        children: [
            withTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: `${(topThree_module_default()).header} text-center 
                        text-xl md:text-3xl font-bold mt-4 mb-6 lg:mb-12`,
                children: "The Top 3 Antivirus Solutions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `justify-center items-center w-full flex flex-col lg:flex-row`,
                children: listing && listing.slice(0, 3).map((item, idx)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `flex flex-col mb-3 px-10 py-3 lg:px-0 text-xs justify-around w-full items-center ${(topThree_module_default()).offer} h-40 lg:h-52 rounded-md relative lg:w-4/12`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "max-w-[150px]",
                                src: item?.logo?.fullPath,
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center lg:w-4/6 mb-3",
                                children: item.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferUrl/* default */.Z, {
                                zone: config/* affiliateOfferZones.HOME_PAGE */.ZR.HOME_PAGE,
                                target: "_blank",
                                offer: item,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: `rounded-md relative font-bold flex items-center ${(topThree_module_default()).button} px-5 py-3
                                        text-sm`,
                                    children: [
                                        "Get it Now",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "w-4 ml-2",
                                            src: "/assets/right-arrow.svg",
                                            alt: ""
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `hidden ${(topThree_module_default()).badge} ${idx === 0 ? "lg:block" : ""}`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {})
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ var topThree = (TopThree);

// EXTERNAL MODULE: ./src/components/antiviruschoice/bestAntivirusRow/index.tsx
var bestAntivirusRow = __webpack_require__(75578);
// EXTERNAL MODULE: ./src/stores/antiviruschoice/operatingSystem.tsx
var operatingSystem = __webpack_require__(26395);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./pages/antiviruschoice/index.tsx









const FAQ = dynamic_default()(()=>__webpack_require__.e(/* import() */ 99416).then(__webpack_require__.bind(__webpack_require__, 99416)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(99416)
            ]
    }
});
const MainListing = dynamic_default()(()=>__webpack_require__.e(/* import() */ 95597).then(__webpack_require__.bind(__webpack_require__, 95597)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(95597)
            ]
    }
});
var __N_SSP = true;
function Home(props) {
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(operatingSystem/* UserOperatingSystemContextProvider */.H, {
        userOperatingSystem: props.operatingSystem,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(antiVirusChoiceWrapper/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-antivirus-text-black",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(topThree, {
                        withTitle: true,
                        listing: domain?.defaultOffers,
                        gradient: "blue"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bestAntivirusRow/* default */.Z, {
                            zone: config/* affiliateOfferZones.HOME_PAGE */.ZR.HOME_PAGE,
                            comparison: false,
                            offer: domain?.defaultOffers[0],
                            gradient: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainListing, {
                        listing: domain?.defaultOffers
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(topThree, {
                        withTitle: false,
                        listing: domain?.defaultOffers,
                        gradient: "gray"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {})
                ]
            })
        })
    });
}


/***/ }),

/***/ 95830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Badge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "110",
        height: "59",
        viewBox: "0 0 110 59",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    transform: "translate(24.619)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "30.381",
                            cy: "30",
                            r: "25",
                            fill: "#FFF"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#FFC20E",
                            fillRule: "nonzero",
                            d: "M57.28 25.615c-1.3-1.076-1.656-2.869-.946-4.423l.591-1.434c.947-2.152-.236-4.662-2.484-5.26l-1.656-.478c-1.656-.478-2.72-1.912-2.839-3.586V8.88c-.118-2.39-2.247-4.064-4.494-3.706l-1.538.24c-1.656.239-3.312-.479-4.022-2.033l-.71-1.314C38.118.034 35.397-.683 33.505.752l-1.302.956c-1.3.956-3.193.956-4.494 0L26.526.752c-1.893-1.435-4.613-.718-5.678 1.315l-.71 1.314c-.828 1.435-2.484 2.272-4.14 2.033l-1.537-.24C12.213 4.816 9.966 6.49 9.847 8.88l-.118 1.435c-.118 1.673-1.183 3.107-2.839 3.586l-1.42.358c-2.247.598-3.43 3.108-2.483 5.26l.591 1.434c.592 1.554.237 3.347-1.064 4.423L1.33 26.452a3.887 3.887 0 000 5.857l1.183 1.076c1.3 1.076 1.656 2.869.946 4.423l-.592 1.434c-.946 2.152.237 4.662 2.484 5.26l1.42.478c1.656.478 2.72 1.912 2.839 3.586l.118 1.554c.118 2.39 2.248 4.064 4.495 3.706l1.538-.24c1.656-.239 3.312.479 4.021 2.033l.71 1.314c1.065 2.033 3.785 2.75 5.678 1.315l1.301-.956c1.301-.956 3.194-.956 4.495 0l1.183.956c1.892 1.435 4.613.718 5.678-1.315l.71-1.314c.827-1.435 2.483-2.272 4.14-2.033l1.537.24c2.247.358 4.495-1.315 4.613-3.706l.118-1.554c.119-1.674 1.183-3.108 2.84-3.586l1.419-.359c2.247-.597 3.43-3.108 2.484-5.26l-.592-1.434c-.591-1.554-.236-3.347 1.065-4.423l1.183-1.075a3.89 3.89 0 000-5.858l-1.065-.956zm-27.442 23.19c-10.528 0-19.044-8.607-19.044-19.245 0-10.639 8.516-19.245 19.044-19.245 10.527 0 19.044 8.606 19.044 19.245 0 10.638-8.517 19.245-19.044 19.245zM43.559 29.56c0 7.65-6.15 13.866-13.721 13.866-7.57 0-13.721-6.216-13.721-13.866 0-7.65 6.15-13.866 13.72-13.866 7.571 0 13.722 6.215 13.722 13.866z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#FF4F4F",
                    d: "M108.9 37.21c.473.598.119 1.554-.71 1.554H87.592c-.118-.598-.236-1.195-.473-1.673L87 36.97l.118-.12c2.13-1.793 3.312-4.542 3.312-7.291 0-2.75-1.183-5.499-3.193-7.292l-.119-.12.119-.119c.236-.598.473-1.195.591-1.913h20.48c.829 0 1.302.957.71 1.554l-5.914 7.531a.583.583 0 000 .837l5.796 7.172zM.383 37.21c-.473.598-.119 1.554.71 1.554h20.598c.118-.598.236-1.195.473-1.673l.119-.121-.118-.12c-2.13-1.793-3.312-4.542-3.312-7.291 0-2.75 1.183-5.499 3.193-7.292l.119-.12-.119-.119c-.236-.598-.473-1.195-.591-1.913H.975c-.829 0-1.302.957-.71 1.554L6.179 29.2a.583.583 0 010 .837L.383 37.21z"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Badge);


/***/ }),

/***/ 70375:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"topThree_button__R4MIn","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","header":"topThree_header__IRp_7","offer":"topThree_offer__IPh_1","badge":"topThree_badge__F5FKl","bg-top-gradient-blue":"topThree_bg-top-gradient-blue__QqRzW","bg-top-gradient-gray":"topThree_bg-top-gradient-gray__Xyy8T"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,3294,74937,9025,49774,92888,40179], function() { return __webpack_exec__(37767); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);